import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useBilling } from "../contexts/BillingContext";

const Profile: React.FC = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { data, refresh } = useBilling() as any;

  const roleTitles: Record<string, string> = {
    user: "Пользователь",
    owner: "Владелец",
    admin: "Администратор",
    superadmin: "Суперадминистратор",
  };

  useEffect(() => {
    setLoading(true);
    setError(null);
    refresh()
      .catch((e: any) => setError(e?.message || "Ошибка загрузки подписки"))
      .finally(() => setLoading(false));
  }, [refresh]);

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold">Профиль</h1>
      <div className="card p-4">
        <div className="text-sm text-gray-600">Email</div>
        <div className="font-medium">{user?.email}</div>
      </div>

      <div className="card p-4">
        <div className="text-sm text-gray-600">Роль</div>
        <div className="font-medium">
          {roleTitles[user?.role || ""] || user?.role || "—"}
        </div>
      </div>

      <div className="card p-4">
        <div className="flex items-center justify-between">
          <div className="text-lg font-semibold">Подписка</div>
        </div>
        {loading ? (
          <div className="text-sm text-gray-500 mt-2">Загрузка...</div>
        ) : error ? (
          <div className="text-sm text-red-600 mt-2">{error}</div>
        ) : data?.subscription ? (
          <div className="mt-3 space-y-2 text-sm">
            <div>
              <span className="text-gray-600">Тариф:</span>{" "}
              {data.subscription.plan?.name || "—"}
            </div>
            <div>
              <span className="text-gray-600">Статус:</span>{" "}
              {data.subscription.status}
            </div>
            <div>
              <span className="text-gray-600">Начало:</span>{" "}
              {data.subscription.startAt
                ? new Date(data.subscription.startAt).toLocaleString()
                : "—"}
            </div>
            <div>
              <span className="text-gray-600">Действует до:</span>{" "}
              {data.subscription.endAt
                ? new Date(data.subscription.endAt).toLocaleString()
                : "—"}
            </div>
            <div>
              <span className="text-gray-600">Лимит магазинов по тарифу:</span>{" "}
              {typeof data.maxStores === "number"
                ? data.maxStores
                : typeof data.subscription.plan?.maxStores === "number"
                  ? data.subscription.plan?.maxStores
                  : "—"}
            </div>
          </div>
        ) : (
          <div className="text-sm text-gray-500 mt-2">Подписка отсутствует</div>
        )}
      </div>
    </div>
  );
};

export default Profile;
